export default "__VITE_ASSET__1fcb5571__"